import { useContext } from 'react';

import {
  InternalChipGroupContext,
  type InternalChipGroupContextProps,
} from '../contexts/InternalChipGroupContext.js';

/**
 * Hook for accessing the _InternalChipGroupContext.
 * @internal
 */
export const useInternalChipGroupContext = (): InternalChipGroupContextProps =>
  useContext(InternalChipGroupContext);
